import { takeLatest, call, select, put, delay } from "redux-saga/effects"

import {
	GET_DOCUMENT_ROW_CLICK_REQUEST,
	GET_DOCUMENT_PAGE_REQUEST,
	GET_FILE_ROW_CLICK_REQUEST,
	GET_FILE_PAGE_REQUEST,
	GET_PAGE_NUMBER_BASED_ON_DOC_ID,
	CONCEPT_BASED_ON_ID,
	GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT,
} from "../types"
import { documentsService } from "../services/documents.services"
import {
	getDocumentRequestSuccess,
	getDocumentRequestFailed,
	getDocumentRequestFailedClear,
	getFileRequestSuccess,
	getFileRequestFailed,
	getFileRequestFailedClear,
	getFileRequestByPageSuccess,
	getFileRequestByPageFailed,
	getFileRequestByPageFailedClear,
	updatePageNumberForCurrentDocument,
	getPageNumberBasedOnHighlightTextSuccess,
	getPageNumberBasedOnHighlightTextFailed,
} from "../actions/documentModalActions"
import { hideAlert, showAlertAction } from "../actions/alertActions"
import { logoutUser } from "../actions/userActions"
import { clearMultibase } from "../actions/multiAiBase"
import { CONTEXT_TYPE, CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage, payloadParsing } from "../utils"
import { setFilterJobId } from "../actions/filterActions"
import axios from "../services/axios"
import axiosClient from "axios"
import { getConceptBasedOnIdFailed, getConceptBasedOnIdSuccess } from "../actions/highlightActions"

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`)
}

const getPsearchStatusByJobId = async (id) => {
	return await axios.get(`/p_search/${id}`)
}

const getConceptById = async (id) => {
	return await axios.get(`/concept/${id}`)
}

function* getDocumentRowClickSaga(action) {
	const id = action.payload
	try {
		const response = yield call(documentsService.getDocumentsData, [id])
		if (response?.data?.success) {
			yield put(getDocumentRequestSuccess(response?.data?.data[0]))
		} else {
			yield put(getDocumentRequestFailed(response.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getDocumentRequestFailedClear())
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getDocumentRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getDocumentRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getDocumentByPageNumSaga(action) {
	const { id, page } = action.payload
	try {
		const response = yield call(documentsService.getDocumentByPageNum, id, page)
		if (response?.data?.success) {
			yield put(getDocumentRequestSuccess(response?.data?.data[0]))
		} else {
			yield put(getDocumentRequestFailed(response.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getDocumentRequestFailedClear())
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getDocumentRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getDocumentRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getFileRowClickSaga(action) {
	let context, context_id, fileId

	if (action?.payload?.reviewId) {
		fileId = action?.payload?.id
		context = CONTEXT_TYPE?.REVIEW
		context_id = action?.payload?.reviewId
	} else if (action?.payload?.searchId) {
		fileId = action?.payload?.id
		context = CONTEXT_TYPE?.SEARCH
		context_id = action?.payload?.searchId
	} else {
		fileId = action.payload
	}

	try {
		const response = yield call(documentsService.getFilesMetadata, [fileId], context_id, context)
		if (response?.data?.success) {
			yield put(getFileRequestSuccess(response?.data?.data[0]))
		} else {
			yield put(getFileRequestFailed(response?.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getFileRequestFailedClear())
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getFileRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getFileRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getFileByPageNumSaga(action) {
	const { id, page, reviewId, searchId } = action.payload
	let context, contextId, fileId

	if (reviewId) {
		fileId = id
		context = CONTEXT_TYPE?.REVIEW
		contextId = reviewId
	} else if (searchId) {
		fileId = id
		context = CONTEXT_TYPE?.SEARCH
		contextId = searchId
	} else {
		fileId = id
	}
	try {
		const response = yield call(documentsService.getFileByPageNum, id, page, contextId, context)
		if (response?.data?.success) {
			yield put(getFileRequestByPageSuccess(response?.data?.data?.content))
		} else {
			if (response?.status === 204) {
				yield put(getFileRequestByPageSuccess("File format not supported"))
			} else {
				yield put(getFileRequestByPageFailed(response?.message))
				yield delay(3000) //After 3sec message disappear
				yield put(getFileRequestByPageFailedClear())
			}
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getFileRequestByPageFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getFileRequestByPageFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getPageNumberBasedOnFileIdSaga(action) {
	try {
		const payload = {
			file_id: action?.payload?.restrict_file_ids[0],
			terms: action?.payload?.text,
			concept_ids: action?.payload?.categories,
		}
		const response = yield call(documentsService.getPageSearchOnDocuments, payload)

		if (response?.data?.success) {
			const pageNumberObject = response?.data?.data
			const pageNumber = pageNumberObject?.map((item) => {
				return item?.page_number
			})
			yield put(
				updatePageNumberForCurrentDocument(
					pageNumber?.sort(function (a, b) {
						return a - b
					}) || []
				)
			)
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getPageNumberBasedOnHighlightTextSaga(action) {
	try {
		const payload = {
			file_id: action?.payload?.restrict_file_ids[0],
			terms: action?.payload?.text,
			concept_ids: action?.payload?.categories,
		}
		const response = yield call(documentsService.getPageSearchOnDocuments, payload)
		if (response?.data?.success) {
			const pageNumberObject = response?.data?.data
			const pageNumber = pageNumberObject?.map((item) => {
				return item?.page_number
			})
			yield put(
				getPageNumberBasedOnHighlightTextSuccess(
					pageNumber?.sort(function (a, b) {
						return a - b
					}) || []
				)
			)
		} else {
			yield put(getPageNumberBasedOnHighlightTextFailed())
		}
	} catch (error) {
		yield put(getPageNumberBasedOnHighlightTextFailed())
		console.log(error)
	}
}

function* getConceptBasedOnIdSaga(action) {
	try {
		for (let i = 0; i < action?.payload?.length; i++) {
			const result = yield call(getConceptById, action?.payload[i])

			if (result.status === 200 && result.data.success === true) {
				yield put(getConceptBasedOnIdSuccess(result?.data?.concept?.visual?.search_terms)) //update store
			} else {
				yield put(getConceptBasedOnIdFailed(result))
			}
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}
				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* documentModalSagas() {
	yield takeLatest(GET_DOCUMENT_PAGE_REQUEST, getDocumentByPageNumSaga)
	yield takeLatest(GET_DOCUMENT_ROW_CLICK_REQUEST, getDocumentRowClickSaga)
	yield takeLatest(GET_FILE_ROW_CLICK_REQUEST, getFileRowClickSaga)
	yield takeLatest(GET_FILE_PAGE_REQUEST, getFileByPageNumSaga)
	yield takeLatest(GET_PAGE_NUMBER_BASED_ON_DOC_ID, getPageNumberBasedOnFileIdSaga)
	yield takeLatest(CONCEPT_BASED_ON_ID, getConceptBasedOnIdSaga)
	yield takeLatest(GET_PAGE_NUMBER_BASED_ON_HIGHLIGHT_TEXT, getPageNumberBasedOnHighlightTextSaga)
}
